import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route changes, EXCEPT when only the language segment (/mx <-> /en) changes.
// When the URL has a hash, scrolls to that element instead of the page top.
const stripLang = (pathname) => pathname.replace(/^\/(mx|en)(?=\/|$)/i, "") || "/";

export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const normalized = stripLang(pathname);

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          const top = rect.top + window.pageYOffset - 60;
          window.scrollTo({ top, left: 0, behavior: "auto" });
        } else if (attempt < 40) {
          setTimeout(() => tryScroll(attempt + 1), 80);
        }
      };
      setTimeout(() => tryScroll(), 30);
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [normalized, hash, key]);

  return null;
}
